module.exports = __webpack_public_path__ + "img/noData.edea05b7.png";